import $ from 'jquery';

// DISABLING PARALLAX

// // WATERCOLOR PARALLAX
// (function() { // Begin scoping function

//   function moveElement(element, start, end) {

//     // Find current window position
//     var top_of_window = $(window).scrollTop();
//     var bottom_of_window = $(window).scrollTop() + $(window).height();

//     var element_height = element.height();
//     var element_midpoint = element.offset().top + (0.5 * element_height);

//     var m = bottom_of_window + (0.5 * element_height);
//     var t = top_of_window - (0.5 * element_height);
//     var range = m-t;

//     var percent_scrolled = 1 - ((m - element_midpoint) / range)

//     percent_scrolled = Math.min(percent_scrolled, 1);
//     percent_scrolled = Math.max(percent_scrolled, 0);

//     var newBottom = start + ((end - start) * percent_scrolled);

//     element.css('transform', "translateY(" + newBottom + "px)");
//   }

//   function moveParallax(){

//     $('.parallax-slower-2').each(function(index) {
//       moveElement($(this), 50, -50);
//     });

//     $('.parallax-slower-1').each(function(index) {
//       moveElement($(this), 20, -20);
//     });

//   };

//   $(window).bind('scroll', moveParallax);

// })(); // End scoping function
